import Profile from "../../slices/users/profile/Profile";
import FamilyMember from "../../slices/users/profile/FamilyMember";
import User from "../../slices/users/user/User";
import PremiseUser from "../../slices/users/premise_user/PremiseUser";
import ServiceProvider from "../../slices/users/serviceProvider/ServiceProvider";
import StaffAttendance from "../../slices/users/staffAttendance/StaffAttendance";
import PremiseUserAttendance from "../../slices/users/premiseUserAttendance/PremiseUserAttendance";
import ChangeRequest from "../../slices/users/change_request/ChangeRequest";
import Payroll from "../../slices/users/payroll/Payroll";
import RoleUser from "../../slices/users/role_user/RoleUser";

const usersReducer = {
    profile: Profile,
    familyMember: FamilyMember,
    user: User,
    premiseUser: PremiseUser,
    serviceProvider: ServiceProvider,
    staffAttendance: StaffAttendance,
    premiseUserAttendance: PremiseUserAttendance,
    changeRequest: ChangeRequest,
    payroll: Payroll,
    roleUser: RoleUser,
};

export default usersReducer;